export enum TypeModal {
    ADD = 'ADD',
    EDIT = 'EDIT',
    ADD_PARRENT = 'ADD_PARRENT'
};
